// extracted by mini-css-extract-plugin
export default {"hover":"Button-module__hover___crTDy","stretch":"Button-module__stretch___hQuR8"};